import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';

class QueryAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  getQueries() {
    return this.api
               .get('/queries')
               .then(data => ({ queries: data.body.data }));
  }
}

class QueryAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getQueryServiceUrl(), token);
    this.queries = new QueryAPIWrapper(this);
  }
}

export default QueryAPI;
